import { useTranslation } from 'react-i18next';
import { Skeleton } from '@monksflow/monks-ui';

import { SPECIAL_AGENT_IDS } from '@/entities/agent';
import { ROUTES } from '@/shared/config/routes';
import { ToolBadge } from '@/shared/ui/ToolBadge';
import { useAdminAgents } from '@/features/admin/model/useAdminAgents';
import { getAdminToolsListDisplayName } from '@/features/admin/lib/canonicalAdminToolLabels';

import { AdminPageShell } from '../AdminPageShell';
import { AgentBasicInformationSection } from './AgentBasicInformationSection';

export function AudienceAgentConfigPage() {
  const { t } = useTranslation('admin');
  const agentId = SPECIAL_AGENT_IDS.AUDIENCE_FLOW;
  const title = getAdminToolsListDisplayName(agentId, '');

  // The same query the section below reads, so this shares its request rather than adding one.
  const { data: agents = [], isLoading } = useAdminAgents();
  const agent = agents.find((a) => a.id === agentId);

  // `ownsBodyInset`: the padded scroll region below is this page's own inset, and it is
  // exactly the one the shell would otherwise add.
  return (
    <AdminPageShell
      title={title}
      titleIcon={
        isLoading ? (
          // Holds the badge's place, so the title does not shift when the tag arrives.
          <Skeleton className="size-6 rounded-sm" />
        ) : (
          agent && <ToolBadge toolId={agentId} category={agent.tag} size="xs" />
        )
      }
      parents={[{ label: t('admin.adminLayout.tools'), href: ROUTES.ADMIN_TOOLS }]}
      ownsBodyInset
    >
      <div className="flex-1 px-6 py-6 overflow-y-auto">
        <AgentBasicInformationSection agentId={agentId} />
      </div>
    </AdminPageShell>
  );
}
